export default __webpack_public_path__ + "static/media/disable.18c9ee59.svg";